// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-asset.page.title': 'Assets',
    'team-member-asset.page.archive.title': 'Archived Assets',
    'team-member-asset.page.search_results': 'Search Results',
    'team-member-asset.page.create.title': 'Create New Asset',
    'team-member-asset.page.search.title': 'Find Assets',
    'team-member-asset.page.edit.title': 'Edit Asset',
    'team-member-asset.page.view.title': 'Asset',
    'team-member-asset.page.all': 'All',

    'team-member-asset.button.cancel': 'Cancel',
    'team-member-asset.button.select': 'Select',
    'team-member-asset.button.find': 'Find Assets',
    'team-member-asset.button.search': 'Apply',
    'team-member-asset.button.create': 'Save Asset',
    'team-member-asset.button.new': 'New Asset',
    'team-member-asset.button.save': 'Save Changes',
    'team-member-asset.button.archive': 'Archive',
    'team-member-asset.button.delete': 'Permanently Delete',
    'team-member-asset.button.edit': 'Edit',
    'team-member-asset.button.restore': 'Restore',
    'team-member-asset.button.reset': 'Reset',

    'team-member-asset.placeholder.search': 'Search assets',

    'team-member-asset.link.create_first_team_member_asset': 'Click here to create your first asset',
    'team-member-asset.link.team_member_assets': ' Return to Assets',
    'team-member-asset.link.archive': 'Archived Assets',
    'team-member-asset.link.retry': 'Click here to retry',

    'team-member-asset.checkbox.all': 'Check All',
    'team-member-asset.checkbox.actions_label': 'with selected',

    'team-member-asset.label.team_member_name': 'Team Member',

    'team-member-asset.label.asset_make': 'Asset Make',

    'team-member-asset.label.asset_model': 'Asset Model',

    'team-member-asset.label.memo': 'Memo',

    'team-member-asset.label.serial_number': 'Serial Number',

    'team-member-asset.label.from__given_at': 'From given at',
    'team-member-asset.label.to__given_at': 'To given at',
    'team-member-asset.label.given_at': 'Given At',

    'team-member-asset.label.condition_given': 'Condition Given',

    'team-member-asset.label.from__returned_at': 'From returned at',
    'team-member-asset.label.to__returned_at': 'To returned at',
    'team-member-asset.label.returned_at': 'Returned At',

    'team-member-asset.label.condition_returned': 'Condition Returned',

    'team-member-asset.label.from__created_at': 'From created at',
    'team-member-asset.label.to__created_at': 'To created at',
    'team-member-asset.label.created_at': 'Created At',

    'team-member-asset.label.from__updated_at': 'From updated at',
    'team-member-asset.label.to__updated_at': 'To updated at',
    'team-member-asset.label.updated_at': 'Updated At',

    'team-member-asset.label.from__deleted_at': 'From deleted at',
    'team-member-asset.label.to__deleted_at': 'To deleted at',
    'team-member-asset.label.deleted_at': 'Deleted At',

    'team-member-asset.label.status': 'Status',

    'team-member-asset.sort.field_label': 'Field',
    'team-member-asset.sort.direction_label': 'Direction',
    'team-member-asset.sort.direction_ascending': 'Ascending',
    'team-member-asset.sort.direction_descending': 'Descending',

    'team-member-asset.modal.title.team_member_asset_archive': 'Archive Asset',
    'team-member-asset.modal.title.team_member_asset_delete_permanently': 'Delete Asset',
    'team-member-asset.modal.title.team_member_asset_restore': 'Restore Asset',

    'team-member-asset.modal.message.team_member_asset_archive': 'Are you sure that you want to move this asset to the archive? | Are you sure that you want to move these assets to the archive?',
    'team-member-asset.modal.message.team_member_asset_delete_permanently':
        'Are you sure that you want to permanently delete this asset? This action cannot be undone. | Are you sure that you want to permanently delete these assets? This action cannot be undone.',
    'team-member-asset.modal.message.team_member_asset_restore': 'Are you sure that you want to restore this asset? | Are you sure that you want to restore these assets?',

    'team-member-asset.success.message.team_member_asset_created': 'Your asset has been created',
    'team-member-asset.success.message.team_member_asset_updated': 'Your asset has been updated',
    'team-member-asset.success.message.team_member_asset_restored': 'Your asset has been restored | All selected assets were restored',
    'team-member-asset.success.message.team_member_asset_deleted': 'Your asset has been permanently deleted | All selected assets were permanently deleted',
    'team-member-asset.success.message.archived_team_member_assets': 'Your asset was moved to the archive | All selected assets were moved to the archive',

    'team-member-asset.error.message.archived_team_member_assets': 'This asset was already moved to the archive | These assets were already moved to the archive',
    'team-member-asset.error.message.team_member_asset_deleted': 'This asset was already permanently deleted | These assets were already permanently deleted',
    'team-member-asset.error.message.team_member_asset_restored': 'This asset was already restored | These assets were already restored',
    'team-member-asset.error.message.error_loading_page': 'Sorry, there was an error loading asset.| Sorry, there was an error loading assets.',

    'team-member-asset.message.search.no_archived_team_member_assets': "You haven't archived any team any member any assets as yet.",
};
